import { render, staticRenderFns } from "./TreatmentPPSCard.vue?vue&type=template&id=5e37104e&"
import script from "./TreatmentPPSCard.vue?vue&type=script&lang=js&"
export * from "./TreatmentPPSCard.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPPSCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports